import classnames from "@src/utils/classnames"
import classNames from "classnames"
import React from "react"
import * as styles from "./numbers.module.scss"

const Numbers = ({ className, children, white }) => {
  const numbers = typeof children === "number" ? children.toString() : children
  if (typeof numbers !== "string") {
    return null
  }
  const letters = numbers.split("")
  return (
    <span
      className={classnames(
        styles.numbers,
        { [styles.white]: white },
        className
      )}
    >
      {letters.map((text, i) => {
        return (
          <span
            key={i}
            className={classNames(styles.number, {
              [styles.one]: text === "1",
            })}
            style={{
              position: "relative",
              zIndex: letters.length - i,
            }}
          >
            {text}
          </span>
        )
      })}
    </span>
  )
}

export default Numbers
